module.exports = (__webpack_require__(0))(204);


//////////////////
// WEBPACK FOOTER
// delegated ./src/router.js from dll-reference girder_plugin_large_image
// module id = 35
// module chunks = 0